// extracted by mini-css-extract-plugin
export default {"container":"snow-board_container__liNMA","hooks":"snow-board_hooks__3lXyA","hook-anchors":"snow-board_hook-anchors__T5Km6"};